import { api } from "@/lib/api";

const API = process.env.REACT_APP_BACKEND_URL;

export const proPdfUrl = (kind, inline = false) => `${API}/api/pro-catalogue/pdf/${kind}${inline ? "?inline=1" : ""}`;

/** Imprime un PDF depuis son adresse. Téléphone/tablette : ouvre le PDF (l'impression d'un PDF caché y est bloquée). */
function printUrl(src, busyKey, setBusy) {
  if (window.matchMedia("(pointer: coarse)").matches) {
    window.open(src, "_blank", "noopener");
    return;
  }
  setBusy(busyKey);
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  f.src = src;
  f.onload = () => {
    setBusy(false);
    try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(src, "_blank", "noopener"); }
  };
  document.body.appendChild(f);
  setTimeout(() => setBusy(false), 8000);
  setTimeout(() => f.remove(), 120000);
}

export function printProPdf(kind, setBusy) {
  printUrl(proPdfUrl(kind, true), kind, setBusy);
}

/** Bon de commande avec tarifs HT/TTC : PDF réservé à l'admin, récupéré avec la session admin. */
export async function pricedOrderUrl() {
  const r = await api.get("/admin/pro-catalogue/order-priced.pdf", { responseType: "blob" });
  return URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
}

export async function printPricedOrder(setBusy) {
  setBusy("order");
  try {
    printUrl(await pricedOrderUrl(), "order", setBusy);
  } finally {
    setTimeout(() => setBusy(false), 8000);
  }
}
